import { pickEnum, pickString } from "@/lib/search-params";

export const ADMIN_AGENT_TABS = ["conversations", "runs"] as const;
export const ADMIN_AGENT_CHANNELS = ["whatsapp", "telegram", "email"] as const;
export const ADMIN_AGENT_THREAD_STATUSES = ["active", "escalated"] as const;
export const ADMIN_AGENT_RUN_STATUSES = ["running", "succeeded", "failed"] as const;

export type AdminAgentsTab = (typeof ADMIN_AGENT_TABS)[number];
export type AdminAgentChannel = (typeof ADMIN_AGENT_CHANNELS)[number];
export type AdminAgentThreadStatus = (typeof ADMIN_AGENT_THREAD_STATUSES)[number];
export type AdminAgentRunStatus = (typeof ADMIN_AGENT_RUN_STATUSES)[number];

export interface AdminAgentsSearch {
  tab: AdminAgentsTab;
  channel?: AdminAgentChannel;
  status?: AdminAgentThreadStatus;
  q?: string;
  thread?: string;
  task?: string;
  runStatus?: AdminAgentRunStatus;
  subject?: string;
  run?: string;
}

export type UpdateAdminAgentsSearch = (patch: Partial<AdminAgentsSearch>) => void;

/** Validates the `/admin/agents` search params; unknown or malformed values are dropped. */
export function parseAdminAgentsSearch(raw: Record<string, unknown>): AdminAgentsSearch {
  return {
    tab: pickEnum(raw.tab, ADMIN_AGENT_TABS, "conversations"),
    channel: pickEnum(raw.channel, ADMIN_AGENT_CHANNELS),
    status: pickEnum(raw.status, ADMIN_AGENT_THREAD_STATUSES),
    q: pickString(raw.q),
    thread: pickString(raw.thread),
    task: pickString(raw.task),
    runStatus: pickEnum(raw.runStatus, ADMIN_AGENT_RUN_STATUSES),
    subject: pickString(raw.subject),
    run: pickString(raw.run),
  };
}
